let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Z8lzP")).then(() => parcelRequire('joBQW'));